var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:flex md:items-center md:justify-between bg-blue-900 sm:px-6 lg:px-8 py-10"},[_c('div',{staticClass:"flex-1 min-w-0"},[_c('h2',{staticClass:"text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate"},[_vm._v("Products")])])])
}]

export { render, staticRenderFns }